
    import Vue from 'vue'
    import router from "../router";
    import ReziseSensor from "css-element-queries/src/ResizeSensor";
    import VuePlotly from '@statnett/vue-plotly'
    import { home } from '../config/home'


    export default Vue.extend({
        name: 'Home',
        metaInfo: {
            title: 'QDRA',
            meta : [
                {
                    name: 'description',
                    content : 'Thunderstorms and Cyclones are a part of life in Australia. The Queensland Disaster Research Alliance (QDRA) is a state-based University collaboration that aims to grow and integrate Queensland’s capability and capacity to deliver high impact and at-scale disaster management research outcomes for the state, nationally and internationally.'
                },
                {
                    name: 'keywords',
                    content : 'cyclones, thunderstorms, disasters, floods, fires, Australia, Queensland, houses, storm preparation, cyclone, weather, storm, protection, collaboration, disaster management, research, education'
                }
            ]
        },
        components: {
        },

        data: () => ({

            "frames": [],
            "home" : home,
            options: {
                "autoresize": true,
                "autosize": true,
                "autosizable": true,
                "reponsive": true
            },
            autoresize: true,
            articles: [
                {
                    src: 'anemometer-DW-tile.jpg',
                    title: 'SWIRLNET',
                    text: 'We provide real time wind speed monitoring for cyclones crossing the Queensland coast.',
                    link: 'https://www.jcu.edu.au/swirlnet'
                },
                {
                    src: 'nqstip.jpeg',
                    title: 'NQSTIP ',
                    text: 'The North Queensland Strata Title Inspection Program (NQSTIP) is at the forefront of improving the resilience of strata properties in North Queensland. Sign up to request an inspection of your property.',
                    link: 'https://stp1.hpc.jcu.edu.au'
                },
                {
                    src: 'palm-tree-wind.jpg',
                    title: 'WEATHER THE STORM',
                    text: 'Helping you strengthen the key connections of your house to withstand severe weather.',
                    link: 'https://weatherthestorm.com.au'
                },
            ],
            partners2: [
                {
                    src: 'QLDGovt-logo.jpeg',
                    title: '',
                    text: '',
                    link: 'https://www.qld.gov.au/'
                },
            ],
            partners1: [
                {
                    src: 'cqu.png',
                    title: '',
                    text: '',
                    link: 'https://www.cqu.edu.au/'
                },





                {
                    src: 'jcu.png',
                    title: '',
                    text: '',
                    link: 'https://www.jcu.edu.au/'
                },
                {
                    src: 'usq.png',
                    title: '',
                    text: '',
                    link: 'https://www.unisq.edu.au/'
                },
                {
                    src: 'grif.png',
                    title: '',
                    text: '',
                    link: 'https://www.griffith.edu.au/research/disaster-network'
                },



                {
                    src: 'usc.png',
                    title: '',
                    text: '',
                    link: 'https://www.usc.edu.au/'
                },





                {
                    src: 'qut.jpg',
                    title: '',
                    text: '',
                    link: 'https://www.qut.edu.au/'
                },
                {
                    src: 'oqcs.png',
                    title: '',
                    text: '',
                    link: 'https://www.chiefscientist.qld.gov.au/'
                },
                {
                    src: 'uq.png',
                    title: '',
                    text: '',
                    link: 'http://uq.edu.au/'
                },




            ],
            examples: [
                {
                    src: 'damage-examples/minor.jpg',
                    title: 'Minor Damage',

                },
                {
                    src: 'damage-examples/moderate.jpg',
                    title: 'Moderate Damage',

                },
                {
                    src: 'damage-examples/severe.jpg',
                    title: 'Severe Damage',

                },
            ],
            videos: [
                {
                    src: 'https://www.youtube.com/embed/h5WAzQxJg7w',
                    title: 'Get Approvals and Contact Your Builder',
                    text: 'Get approvals from authorities and contact a licensed builder.',
                    link: 'approvals'
                },

                {
                    src: 'https://www.youtube.com/embed/h5WAzQxJg7w',
                    title: 'Understand How Winds Affect Houses',
                    text: 'Understand wind loads and learn about the principles of retrofitting.',
                    link: 'wind'
                },
                {
                    src: 'https://www.youtube.com/embed/h5WAzQxJg7w',
                    title: 'Resources for Building Professionals',
                    text: 'Here are some resources for building professionals.',
                    link: 'resources'
                },
            ],
            features: [
                {
                    icon: 'mdi-hammer-wrench',
                    title: 'Resilience',
                    subtitle: 'Improving the Resilience of Properties',
                    text: 'We help identify resilience categories for properties and give recommendations.',
                    link: 'resilience',
                    highlight: false,
                    elevation: 0,
                    color: "grey darken-1"
                },
                {
                    icon: 'mdi-shield-star-outline',
                    title: 'TESTING',
                    subtitle: 'NATA ACCREDITED Material Testing Services',
                    text: 'We have in-house expertise and a fully equipped facility to help with your testing needs.',
                    link: 'testing',
                    highlight: false,
                    elevation: 0,
                    color: "grey darken-1"
                },
                {
                    icon: 'mdi-weather-windy',
                    title: 'WIND ENGINEERING',
                    subtitle: '2.5m x 2.0m x 22m Boundary Layer Wind Tunnel',
                    text: 'Our research finds many practical applications in wind loading standards and building codes of practice.',
                    link: 'wind',
                    highlight: true,
                    elevation: 0,
                    color: "grey darken-1"
                },
                {
                    icon: 'mdi-home-flood',
                    title: 'WATER INGRESS',
                    subtitle: 'At the forefront of damage investigations',
                    text: 'We try to understand what building products and systems perform well, as well as identifying areas for improvement.',
                    link: 'water',
                    highlight: true,
                    elevation: 0,
                    color: "grey darken-1"
                },
                /*{
                    icon: 'mdi-home-roof',
                    title: 'LEVEL 4',
                    subtitle: 'Roof and Wall Tie-Down Retrofit',
                    text: 'Coming Up Soon.',
                    link: 'todo',
                    highlight: false
                },
                {
                    icon: 'mdi-playlist-check',
                    title: 'Select a Level of Retrofitting',
                    text: 'Some retrofitting tasks should be performed before others.',
                    link: 'select/levels'
                },
                {
                    icon: 'mdi-home',
                    title: 'Select Your House-Type to get Customised Retrofit Details',
                    text: 'Select the category your house falls in. This will help you decide which retrofits are suitable.',
                    link: 'select'
                },
                {
                    icon: 'mdi-playlist-check',
                    title: 'Get Approvals and Contact Your Builder',
                    text: 'Get approvals from authorities and contact a licensed builder.',
                    link: 'select/approvals'
                },
                {
                    icon: 'mdi-playlist-check',
                    title: 'Get Approvals and Contact Your Builder',
                    text: 'Get approvals from authorities and contact a licensed builder.',
                    link: 'select/approvals'
                },*/
               /*,
                {
                    icon: 'mdi-weather-windy',
                    title: 'Understand Wind Loads and House Structures',
                    text: 'Understand the relationship between wind loads and house structures.',
                    link: 'select/wind'
                },
                {
                    icon: 'mdi-ruler-square',
                    title: 'Understand the Principles of Retrofitting',
                    text: 'In order to protect your house you must understand the basics.',
                    link: 'select/principles'
                }*/
            ],
            partners: [
                {
                    src: 'geo-logo.jpg',
                    ratio: 3.41,
                    title: 'Get Approvals and Contact Your Builder',
                    text: 'Get approvals from authorities and contact a licensed builder.',
                    link: 'select/approvals'
                },
                {
                    src: 'bush-logo.jpg',
                    title: 'Window and Door Protection',
                    text: 'Protecting windows and door can reduce the risk of internal pressurization and water ingress.',
                    link: 'resources',
                    ratio: 2.68
                },
              /*  {
                    src: 'cts-logo.jpg',
                    title: 'Contact Your Builder',
                    text: 'Funding and incentive schemes.',
                    link: 'select/approvals',
                    ratio: 2.32
                },*/
            ],
        }),
        methods: {
            gotoSelect() {
                router.push('/select').catch(err => {
                    return err
                })
            },
            gotoHome() {
                router.push('/').catch(err => {
                    return err
                })
            },
            gotoWind() {
                router.push('/wind').catch(err => {
                    return err
                })
            },
            gotoResources() {
                router.push('/resources').catch(err => {
                    return err
                })

            }
        },
        computed: {
            minHeight () {
                const height = this.$vuetify.breakpoint.mdAndUp ? '100vh' : '100vh'

                return `calc(${height} - ${this.$vuetify.application.top}px)`
            },
        }

    })
